import moment from 'moment';
import axios from 'axios';
import httpClient from '@/utils/httpClient';
import GuestMixin from './GuestMixin';
import PopUpMixin from './dinamicPopUpMixin';
import { mapState } from "vuex";



export default {
    mixins: [GuestMixin, PopUpMixin],
    data() {
        return {
            showPreJoinModal: false
        }
    },
    methods: {
        closePreJoinModal() {
            this.showPreJoinModal = false
            window.location.replace(process.env.VUE_APP_HOME_PAGE)
        },
        getUser() {
            this.$emit('guestSetted')
        },
        getSharedEstimated(price) {
            return Number((price / 2).toFixed(0));
        },
        roundNumber(floatNum) {
            return Math.ceil(floatNum);
        },
        getFormattedDate(dateTrip) {
            return moment(dateTrip, 'YYYY-MM-DD').format('MM-DD-YYYY');
        },
        getFormattedTime(time) {
            return moment(time, 'HH:mm:ss').format('HH:mm A');
        },
        getEstimatedLabel() {
            let label = '';
            if (this.trip.flightTimeHours > 1) {
                label = this.trip.flightTimeHours + " hours ";
            } else if (this.trip.flightTimeHours == 1) {
                label = this.trip.flightTimeHours + " hour ";
            }

            if (this.trip.flightTimeMinutes > 0 && this.trip.flightTimeMinutes < 60) {
                label += this.trip.flightTimeMinutes + ' min';
            }
            return label;
        },
        notifyAboutFailedValidation() {
            console.log('notifyAboutFailedValidation');
        },
        sendMessage(message) {
            let params = {
                trip_id: this.trip.id,
                message_body: message,
            };

            axios.post('api/messages', params)
                .then(() => {
                    this.$swal({
                            title: 'OK',
                            icon: 'success',
                            text: 'Your message has been sent. SharedCharter will get in touch with you.',
                            confirmButtonText: 'OK',
                        })
                        .then(() => {
                            //Log In
                            this.$router.push({ name: 'TripSearch' });
                        })
                })
        },
        saveNewPhone(phone) {
            httpClient.patch('api/user/' + this.user.id + '/update-phone', {
                phone: phone
            })
        },
        saveNewRequest() {
            let params = {
                trip_id: this.trip.id,
                seats: 1,
                message: 'I want to join your flight',
            };

            let route = 'api/trip-requests';

            if (!this.$store.state.auth) {
                route = 'api/trip-requests-guests';
                params.email = this.email
            }
            httpClient.post(route, params).then(
                () => {
                    if (process.env.VUE_APP_ENV == 'production') {
                        window.ga('send', 'event', 'Lead', 'Joined');
                    }
                    this.showPreJoinModal = true
                }
            ).catch(() => {
                this.$swal({
                    title: 'Error',
                    icon: 'danger',
                    text: 'Sorry, something happened and we could not process your request.',
                    confirmButtonText: 'OK',
                })
            })
        },
    },
    computed: {
        ...mapState('users', {
            user: state => state.user
        }),
    }
}